<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <data-table 
                        :headings="customerDiscountGroupsHeadings" 
                        :data="discountGroups" 
                        :hasActions="true" 
                        :pagingDetails="pagingDetails"
                        :stateChanged="filterStateChanged"
                        @actionClicked="onDiscountGroupActionClicked"
                        @filterSearchClicked="onFilterSearchClicked">
                    <template #filter>
                        <div class="p-3">
                            <div class="input-group pb-4">
                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                           :componentId="'customerFilterRadioButtons'"
                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                        </div>
                    </template>
                </data-table>
            </div>
        </div>
    </div>
    <customer-discount-group-products-modal
            :heading="customerDiscountGroupLinkedProductsModal.heading"
            :modalId="customerDiscountGroupLinkedProductsModal.modalId"
            :showModal="customerDiscountGroupLinkedProductsModal.showModal"
            :customerDiscountGroupId="customerDiscountGroupLinkedProductsModal.customerDiscountGroupId"
            @okClicked="onCustomerDiscountGroupProductModalOkClick"></customer-discount-group-products-modal>
</div>
